import { SetNewPasswordForm } from '../../../components/forms';

export const SetNewPassword = () => {
  return (
    <div className="columns">
      <SetNewPasswordForm />
    </div>
  );
};
